import { Bar } from "react-chartjs-2"
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement } from "chart.js"
import { CustomChartType } from "../../types"
ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend)

export default function PaymentStatisticsChart(props: CustomChartType) {
    // Chart data
    const data = {
        labels: props.paymentStatistics?.map((item: any) => item.monthYear), // X-axis labels
        datasets: [
            {
                label: "Erhalten",
                data: props.paymentStatistics?.map((item: any) => item.received_amount),
                backgroundColor: "rgba(2, 163, 58, 0.6)", // Teal color
                borderColor: "rgba(2, 163, 58, 1)",
                borderWidth: 1,
            },
            {
                label: "Angefordert",
                data: props.paymentStatistics?.map((item: any) => item.requested_amount),
                backgroundColor: "rgba(163, 15, 2, 0.6)", // Red color
                borderColor: "rgba(163, 15, 2, 1)",
                borderWidth: 1,
            },
        ],
    }

    return (
        <div className="w-full md:w-2/3 bg-white rounded-default shadow-lg p-4">
            <Bar
                className="w-full md:grow h-80 sm:h-96 md:h-full"
                data={data}
                options={{
                    responsive: true,
                    plugins: {
                        legend: {
                            position: "top",
                        },
                        title: {
                            display: true,
                            text: "Zahlungsanforderungen pro Monat",
                        },
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                        },
                    },
                }}
            />
        </div>
    )
}
